module.exports = __webpack_public_path__ + "img/8.62b406d6.jpeg";